import type { RescanComparison, RescanComparisonResponse } from '../types';
import { callUIAPI } from '@utils/apiUtils';

const unwrap = <T>(res: { data?: T } | T): T => {
  if (res && typeof res === 'object' && 'data' in (res as Record<string, unknown>)) {
    return (res as { data: T }).data;
  }
  return res as T;
};

export const getRescanComparison = async (companyId: number, scanId?: number | null): Promise<RescanComparison | null> => {
  const scanParam = scanId != null ? `&scanId=${scanId}` : '';
  const res = await callUIAPI(`rescans/compare?companyId=${companyId}${scanParam}`, null, 'get', true);
  const body = unwrap<RescanComparisonResponse | null>(
    res as { data?: RescanComparisonResponse | null },
  );
  if (!body || body.hasScan === false) {
    return null;
  }
  return body.comparison;
};

